module.exports = __webpack_public_path__ + "img/Olav_og_Kari_Jomfru_Maria.a81041c9.jpg";